import { Badge, Tooltip } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import { useIsATSConnected } from '@/react-query/team'

const BADGE_CONFIG: Record<
  string,
  { label: string; color: string; tooltip: string } | null
> = {
  matched: {
    label: '✅ ATS Matched',
    color: 'green',
    tooltip:
      'Candidate and application matched automatically from your ATS data.',
  },
  'candidate-matched': {
    label: '🔍 Candidate Detected',
    color: 'blue',
    tooltip: 'Candidate identified in ATS but no application link found yet.',
  },
  unmatched: {
    label: 'ATS Unmatched',
    color: 'gray',
    tooltip:
      'This interview was detected from your calendar but could not be matched to an ATS candidate.',
  },
  // User explicitly cleared the candidate/role — no badge
  'user-cleared': null,
}

export const AtsMatchBadge = () => {
  const { data: interview } = useInterview()
  const isATSConnected = useIsATSConnected()
  const matchStatus = interview?.matchStatus as string | undefined

  const badgeConfig = matchStatus ? BADGE_CONFIG[matchStatus] : undefined

  if (!isATSConnected || !matchStatus || !badgeConfig) {
    return null
  }

  // "View in ATS" link already communicates the match — no need for the badge
  if (interview?.Candidate?.atsProfileUrl) {
    return null
  }

  const { label, color, tooltip } = badgeConfig

  return (
    <Tooltip label={tooltip} placement="top" hasArrow>
      <Badge
        colorScheme={color}
        fontSize="0.65rem"
        fontWeight="500"
        px={2}
        py={0.5}
        borderRadius="md"
        cursor="help"
      >
        {label}
      </Badge>
    </Tooltip>
  )
}
